import React from "react"
import { Card, CardBody, CardHeader } from "reactstrap"
import { SubContractorInvoiceListContainer } from "components/subContractorInvoices/redux/SubContractorInvoiceContainers"
import Icon from "components/common/Icon"

const SubContractorInvoiceCardBasic = () => {
    return (
        <Card>
            <CardHeader>
                <h6>
                    <Icon invoice />
                    Sub Contractor Invoices
                </h6>
            </CardHeader>
            <CardBody>
                <SubContractorInvoiceListContainer />
            </CardBody>
        </Card >
    )
}

export default SubContractorInvoiceCardBasic